import React from "react";

export default function About() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>About Us</h2>
      <p>
        CrackerMart is a family-owned business delivering premium fireworks for over a decade.
        We value safety, quality, and customer satisfaction above all.
      </p>
    </div>
  );
}